import type { Recipient } from '../types';
import type { ReportSendUser } from '@/types/reports';

export function mapReportSendUser(user: ReportSendUser): Recipient {
  const status = user.status.trim().toUpperCase();
  return {
    id: user.id,
    name: user.name,
    email: user.email,
    whatsapp: user.whatsapp,
    status: status === 'ACTIVE' ? 'ativo' : 'pendente',
    alreadySent: user.already_sent,
  };
}
